/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Modal, Button } from '../../../../../components'
import { useDropzone } from 'react-dropzone'

import { DropArea, DropText, ImageBox } from './styles'
import ecbrApi from '../../../../../services/ecbrApi'
import useUrlParam from '../../../../../hooks/useUrlParam'

const CertificateImageModal = ({ onHide, ...rest }) => {
  const [error, setError] = useState('')
  const [productId] = useUrlParam('/admin/certificates/:id')
  const [files, setFiles] = useState(null)

  const onDrop = (fileList) => {
    setError('')
    if (fileList?.length > 0) {
      setFiles(
        fileList.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      )
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/png,image/jpeg,image/jpg'
  })

  const handleUpload = async () => {
    try {
      setError('')
      if (files) {
        await ecbrApi.products.setImage(productId, files[0])
        onHide(false)
      } else {
        setError('Selecione uma imagem')
      }
    } catch (error) {
      setError(error.message)
    }
  }

  return (
    <Modal onHide={onHide} exitOnBackdropClick={false} {...rest}>
      <Modal.Header closeButton>
        <Modal.Title>Novo Certificado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ImageBox>
          {files?.length ? (
            <img
              src={files[0].preview}
              alt={files[0].name ?? 'Pré-visualização da imagem'}
            />
          ) : (
            <DropArea {...getRootProps()}>
              <input
                {...getInputProps()}
                accept=".png,.jpg,image/png,image/jpeg,image/jpg"
              />
              {isDragActive ? (
                <DropText>Solte o arquivo aqui...</DropText>
              ) : (
                <DropText>
                  Arrastre ou clique aqui. Tipos aceitos: png, jpg, jpeg
                </DropText>
              )}
            </DropArea>
          )}
        </ImageBox>
        {error && <p>{error}</p>}
      </Modal.Body>
      <Modal.Footer align="center">
        {(files && (
          <>
            <Button
              text="Descartar"
              variant="outlined"
              width="200px"
              onClick={() => setFiles(null)}
            />
            <Button
              text="Fazer Upload"
              variant="primary"
              width="200px"
              onClick={() => handleUpload()}
            />
          </>
        )) || (
          <Button
            text="Fechar"
            variant="primary"
            width="200px"
            onClick={() => onHide?.(false)}
          />
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default CertificateImageModal
